import postIndicatorsView from './postIndicatorsComponent.html';
import './postIndicatorsComponent.css';

export function postIndicatorsComponent() {
	return {
		bindings: {
			post: '=',
		},
		controllerAs: 'vm',
		controller: postIndicatorsComponentCtrl,
		template: postIndicatorsView,
	};
}

export class postIndicatorsComponentCtrl {
	constructor(/* special injections available: $scope, $element, $attrs */) {
		'ngInject';
		// $scope will be the scope of this custom element
		//     DO NOT use $scope.$eval() to get values, they will be bound to `this`
		//     The only thing to use scope for is $scope.$on('vm.prop') where 'vm.prop' is available here as `this.prop`
		// $element will be the element with this attribute
		//     NOT RECOMMENDED
		// $attrs is the special object containing a property with all the element's attribute values AS STRINGS
		//     NOT RECOMMENDED
	}
}
